<script>
  import { store } from '@store'
  import InfinityScroll from '@components/InfinityScroll'
  import NewsItem from '@components/NewsItem';
  import Breadcrumbs from '@components/Breadcrumbs'

  export let title = '',
    list = [],
    breadcrumbs = []
</script>
<div class="header">
  <div class="title">{title}</div>
  {#if breadcrumbs.length}
    <Breadcrumbs {breadcrumbs} />
  {/if}
  {#if !list.length}
    <div class="null mt-3">
      <h2>Не удалось ничего найти</h2>
    </div>
  {/if}
</div>
{#if list.length}
  <div class="content d-flex justify-content-center">
    <div class="content-wrapper">
      <InfinityScroll>
        {#each list as item}
          <NewsItem {...item} />
        {/each}
      </InfinityScroll>
    </div>
  </div>
{/if}

<style>
  .header {
    text-align: center;
    .title {
      line-height: normal;
      font-size: 1.25rem;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      padding-top: 100px;
      padding-bottom: 30px;
      border-bottom: 1px solid rgba(196, 196, 196, 0.5);
      margin: 0 -100px;
      @media (max-width: 767px) {
        margin: 0 -15px;
      }
    }
  }

  .content {
    margin-top: 50px;
    .content-wrapper {
      max-width: 500px;
    }
  }


</style>
